export const tags = [
    'FrameTime',
    'RecommendedDisplayFrameRate',
];
